// extracted by mini-css-extract-plugin
module.exports = {"hiddenNav":"hiddenNav_hiddenNav__SzOOo"};